<template>
    <div class="main">
        <div class="tag">
            <span :class="{active:active==0}" @click="active=0">我的项目</span>
            <span :class="{active:active==1}" @click="active=1">已发布项目</span>
        </div>
        <div class="return"><span  @click="$router.back()"><<返回</span></div>
        <div class="project" v-if="active==0">
            <div v-if="id==1">
                <div class="add" @click="dialogFormVisible=true"><img src="../assets/images/add.png" alt=""><div>创建新文件</div></div>
                <div class="item" v-for="item in list" @click="review(item)" >
                    <div class="img"><img :src="$store.state.token.path+item.thumbnail" alt=""></div>
                    <div class="handle">
                        <div class="name">{{item.name}}<img src="../assets/images/del.png" alt="" @click.stop="deleteItem(item)"></div>
                        <span>{{item.fileType}}:{{(item.size/1000000).toFixed(2)}}MB</span>
                    </div>
                </div>
            </div>
            <div class="item" v-for="(item,index) in listBand" :key="index" @click="relink(item)" v-else-if="id==3">
                <div class="img"><img :src="item.img" alt=""></div>
                <div class="handle">
                    <div class="name">{{item.name}}</div>
                    <span>{{item.desc}}</span>
                </div>
            </div>
            <div class="item" v-for="(item,index) in listIssue" :key="index" @click="relink2(item)" v-else>
                <div class="img"><img :src="item.img" alt=""></div>
                <div class="handle">
                    <div class="name">{{item.name}}</div>
                    <span>{{item.desc}}</span>
                </div>
            </div>
        </div>
        
        <div v-else class="project">
            <issueProject></issueProject>
        </div>
        <el-dialog title="创建文件" :visible.sync="dialogFormVisible" width="636rem" :close-on-click-modal="false" :before-close="handleClose">
            <el-form :model="form" label-position="left" :rules="rules" ref="form">
                <el-form-item label="名称" :label-width="formLabelWidth">
                    <el-input v-model="form.name" autocomplete="off" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="模型文件" :label-width="formLabelWidth">
                    <div class="model">
                        <el-upload
                            class="avatar-uploader"
                            action="https://local.vrmaker.vip:37086/user/set/avatar/"
                            :show-file-list="false"
                            :auto-upload="false"
                            accept=".rvt,.rfa,.dwg,.dxf,.skp,.ifc,.dgn,.obj,.stl,.3ds,.dae,.ply,.igms,.zip,.gtj,.fbx,.3dxml"
                            :on-change="onProgressModel">
                            <el-button size="small" type="primary">上传模型文件</el-button>
                        </el-upload>
                        <div style="" v-if="file"><i class="el-icon-document"></i> {{file.name}}<span style="margin-left:50px">{{(file.size/1000000).toFixed(2)}}MB</span></div>
                    </div>
                    <div class="tips">支持rvt、rfa、dwg、dxf、skp、ifc、dgn、obj、stl、3ds、dae、ply、igms、zip、gtj等格式。</div>
                </el-form-item>
                <el-form-item label="缩略图" :label-width="formLabelWidth">
                    <div class="upload">
                        <el-upload
                            class="avatar-uploader"
                            action="https://local.vrmaker.vip:37086/user/set/avatar/"
                            :show-file-list="false"
                            :auto-upload="false"
                            accept=".png,.jpge,.jpg"
                            :on-change="onProgressImg">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" width="100%" height="100%">
                            <div v-else>
                                <img src="../assets/images/upload.png" alt="" class="icon">
                                <div class="img">上传项目缩略图</div>
                            </div>
                        </el-upload>
                    </div>
                    <div class="tips">支持jpg、jpeg、png格式，大小不超过2MB。</div>
                </el-form-item>
            </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="submitForm('form')" round style="width:240px" >创建</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>
    import {
        getlogin,getModelList,AddModel,getModelState,getModelView,deleteModel
    } from "../api/common"
    import issueProject from "../components/issueProject.vue"
    export default {
        name: "FileList",
        components:{
            issueProject
        },
        data() {
            return {
                active:0,
                dialogFormVisible: false,
                form: {
                    name: '',
                },
                formLabelWidth: '90px',
                list:[],
                imageUrl: '',
                imageFile:"",
                file:"",
                rules: {
                    name: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                },
                id:"",
                listIssue:[
                    {
                        name:"测试发布模型",
                        desc:"测试发布模型",
                        img:require('../assets/images/img4.png'),
                        url:"http://local.vrmaker.vip:38080/web-bim/gis.html"
                    },
                ],
                listBand:[
                    {
                        name:"联动模型对比",
                        desc:"联动模型对比",
                        img:require('../assets/images/view.png'),
                        url:"http://local.vrmaker.vip:38080/web-bim/bim1.html"
                    }
                ]
            }
        },
        watch: {

        },
        mounted() {
            this.id = this.$route.query.id
            this.getList()
        },
        methods: {
            deleteItem(item){
                deleteModel(item.id).then((res) => {
                    if (res.data.code==200) {
                        this.$message({
                            showClose: true,
                            message: '删除成功！',
                            type: 'success'
                        });
                        this.getList();
                    }
                })
            },
            relink2(){
                this.$router.push({
                    path:'/gis',
                    name:'gis'
                })
            },
            relink(item){
                let href = item.url
                window.open(href, '_blank');
            },
            handleClose(done) {
                this.form.name = ""
                this.imageFile = ""
                this.file = ""
                this.imageUrl = ""
                done();
            },
            review(item){
                this.getFileState(item.fileId)
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.4)'
                    });
                    let obj = {
                        name: this.form.name,
                        projectId: this.id,
                        thumbnail:this.imageFile,
                        modelFile:this.file
                    }
                    AddModel(obj).then((res) => {
                        if (res.data.code==200) {
                            loading.close();
                            this.$message({
                                showClose: true,
                                message: '恭喜你，创建成功！',
                                type: 'success'
                            });
                            this.form.name = ""
                            this.imageFile = ""
                            this.file = ""
                            this.imageUrl = ""
                            this.getList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            onProgressModel(res,file){
                console.log(res)
                this.file = res.raw
            },
            onProgressImg(res,file){
                this.imageFile = res.raw
                this.imageUrl = this.getObjectURL(res.raw)
            },
            getReview(fileId){
                 const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                getModelView(fileId).then((res) => {
                    if (res.data.code==200) {
                        loading.close();
                         this.$router.push({
                            path:'/View',
                            name:'View',
                            query:{viewToken:res.data.data.viewToken}
                        })
                    }
                })
            },
            getFileState(fileId){
                getModelState(fileId).then((res) => {
                    if (res.data.code==200) {
                        if(res.data.data.status=="success"){
                            this.getReview(fileId);
                        }else{
                            this.$message('正在转换模型中，请稍后预览！');
                            return
                        }
                    }
                })
            },
            getObjectURL(file) {
                var url = null ; 
                if (window.createObjectURL!=undefined) { // basic
                    url = window.createObjectURL(file) ;
                } else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file) ;
                } else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file) ;
                }
                return url ;
            },
            getList(){
                let obj = {
                    pageNo:1,
                    pageSize:10,
                    projectId:this.$route.query.id
                }
                getModelList(obj).then((res) => {
                    this.list = res.data.data.content;
                    this.dialogFormVisible = false
                })
                
            }
        }
    };
</script>
<style scoped lang="less">
    .return{
        overflow: hidden;
        margin-top: 20px;
        span{
            float: right;
            z-index: 9999;
            font-size: 21px;
            color: #666;
            cursor: pointer;
        }
        
    }
.main{
    padding: 5vh 10vw;
    background: #F2F5F7;
    overflow: hidden;
    .tag{
        font-size: 18rem;
        line-height: 30px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        span{
            padding: 3px 10px;
            position: relative;
            cursor: pointer;
        }
        .active::before{
            content: "";
            border-bottom: 2px solid #0D94FF;
            position: absolute;
            bottom: -3px;
            width: 40px;
            left: 50%;
            margin-left: -20px;
            z-index: 9;
            display: inline-block;
        }
    }
}
    .project{
        width: 110%;
        overflow: hidden;
        padding-bottom: 23px;
    }
    .tips{
        line-height: 25px;
    }
    .upload{
        height: 240rem;
        background: #EEEEEE;
        border: 1px solid #DCDCDC;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        .icon{
            margin-top: 50rem;
        }
        /deep/.avatar-uploader{
            height: 100%;
        }
        /deep/.el-upload{
            width: 100%;
            height: 100%;
        }
    }
    .add{
        width: 19vw;
        height: 290px;
        border-radius: 12px;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        text-align: center;
        font-size: 18px;
        color: #999999;
        text-align: center;
        cursor: pointer;
        img{
            color: #D2D2D2;
            width: 52px;
            margin-top: 80px;
        }
        &>div{
            margin-top: 20px;
        }
    }
    .item{
        width: 19vw;
        height: 290px;
        overflow: hidden;
        border-radius: 12rem;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        display: inline-block;
        cursor: pointer;
        transition:all .5s;-webkit-transition:all .5s;-ms-transition:all .5s;
        .img{
            height: 200px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .handle{
            padding: 10px 10px;
            .name{
                font-size: 18px;
                margin-bottom: 10px;
                img{
                    width: 18px;
                    float: right;
                    margin-left: 20px;
                    cursor: pointer;
                    display: none;
                }
            }
            span{
                padding: 2px 6px;
                background: #0D94FF;
                border-radius: 12px;
                color: #FFFFFF;
                font-size: 16rem;
                display: inline-block;
            }
        }
    }
    .item1{
        width: 19vw;
        height: 290px;
        overflow: hidden;
        border-radius: 12rem;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        display: inline-block;
        cursor: pointer;
        transition:all .5s;-webkit-transition:all .5s;-ms-transition:all .5s;
        .img{
            height: 200px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .handle{
            padding: 10px 10px;
            .name{
                font-size: 18px;
                margin-bottom: 10px;
                img{
                    width: 18px;
                    float: right;
                    margin-left: 20px;
                    cursor: pointer;
                    display: none;
                }
            }
            span{
                font-size: 16rem;
                color: #666;
                display: inline-block;
            }
        }
    }
        .item:hover{
            -webkit-transform: translateY(-20px);
            -moz-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
            transform: translateY(-20px);
            .name img{
                display: inline-block;
            }
        }
</style>


// WEBPACK FOOTER //
// src/views/FileList.vue